import { PassportMap, IDocument } from 'types';

export const missingPassportNotificationText =
  'Please upload your passport in the General Documents section before recording the video interview.';

const completeStatuses: IDocument['status'][] = ['UPLOADED_OK', 'APPROVED'];
export const hasUploadedPassport = (passportMap: PassportMap): boolean => {
  return Object.values(passportMap).some(p => completeStatuses.includes(p?.status));
};
